export const translations = {
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },

  novoZipcode: {
    pt: "Novo zipcode",
    en: "New zipcode",
    de: "Neue Postleitzahl",
    es: "Nuevo código postal",
  },
  zipcodeInternacional: {
    pt: "zipcode internacional",
    en: "international zipcode",
    de: "internationale Postleitzahl",
    es: "código postal internacional",
  },
  filtersTitle: {
    pt: "Filtro",
    en: "Filter",
    de: "Filter",
    es: "Filtro",
  },
  country: {
    pt: "País",
    en: "Country",
    de: "Land",
    es: "País",
  },
  city: {
    pt: "Cidade",
    en: "City",
    de: "Stadt",
    es: "Ciudad",
  },
  state: {
    pt: "Estado",
    en: "State",
    de: "Bundesland",
    es: "Estado",
  },
  zipcode: {
    pt: "CEP (zip code)",
    en: "Zip code",
    de: "Postleitzahl",
    es: "Código postal",
  },
  resetButton: {
    pt: "Limpar filtros",
    en: "Clear filters",
    de: "Filter löschen",
    es: "Limpiar filtros",
  },
  submitButton: {
    pt: "Filtrar",
    en: "Filter",
    de: "Filtern",
    es: "Filtrar",
  },
};
